import { ChangeDetectorRef, Directive, Input, OnDestroy, TemplateRef, ViewContainerRef } from '@angular/core';
import { BehaviorSubject, combineLatestWith, Observable, Subject, takeUntil } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { InternalOrExternalDispatcherService } from '../services/internal-or-external-dispatcher.service';

@Directive({
  selector: '[tbInternalOrExternalDispatcher]',
})
export class InternalOrExternalDispatcherDirective implements OnDestroy {
  private hasView = false;
  private destroy$$ = new Subject<void>();
  private isInternal$: Observable<boolean>;

  private elseTemplateRef$$ = new BehaviorSubject<TemplateRef<any>>(null);

  @Input()
  public set tbInternalOrExternalDispatcher(_: void) {}

  @Input()
  public set tbInternalOrExternalDispatcherElse(templateRef: TemplateRef<any>) {
    this.elseTemplateRef$$.next(templateRef);
  }

  constructor(
    private authService: InternalOrExternalDispatcherService,
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private cd: ChangeDetectorRef,
  ) {
    this.isInternal$ = this.authService.isInternalOrExternalDispatcherShared$;
    this.listenForViewUpdates();
  }

  public ngOnDestroy(): void {
    this.destroy$$.next();
    this.destroy$$.unsubscribe();
  }

  private listenForViewUpdates() {
    this.isInternal$
      .pipe(takeUntil(this.destroy$$), combineLatestWith(this.elseTemplateRef$$))
      .subscribe(([isInternalOrExternalDispatcher, elseRef]) => {
        if (!isInternalOrExternalDispatcher) {
          this.clearView();
          if (elseRef) {
            this.viewContainer.createEmbeddedView(elseRef);
            this.hasView = true;
          }
          this.cd.markForCheck();
        } else {
          this.clearView();
          this.viewContainer.createEmbeddedView(this.templateRef);
          this.hasView = true;
          this.cd.markForCheck();
        }
      });
  }

  private clearView() {
    if (this.hasView) {
      this.viewContainer.clear();
      this.hasView = false;
      this.cd.markForCheck();
    }
  }
}
